import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import enCommon from "@/locales/en/common.json";
import filCommon from "@/locales/fil/common.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "fil", // PH-first product
    supportedLngs: ["en", "fil"],
    defaultNS: "common",
    ns: ["common"],
    resources: {
      en: { common: enCommon },
      fil: { common: filCommon },
    },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "ps_locale",
    },
    interpolation: {
      escapeValue: false, // React already escapes
    },
  });

export { i18n };
